var map = {
	"./breen.json": 384,
	"./kongsvinger.json": 385,
	"./lauvmakk.json": 386,
	"./lofoten.json": 387,
	"./odal.json": 388,
	"./oppland.json": 389,
	"./oslo.json": 390,
	"./palsmyr.json": 391,
	"./reineier.json": 392,
	"./slinde.json": 393,
	"./tilgamvik.json": 394,
	"./vega.json": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;